"use client";

import Link from "next/link";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[GlobalError]", error);
  }, [error]);

  return (
    <div className="bg-luxury-dark flex min-h-screen flex-col items-center justify-center px-6 py-12 text-center text-white">
      <div className="max-w-xl rounded-2xl border border-white/10 bg-white/5 p-10 backdrop-blur">
        <p className="text-luxury-green mb-4 text-sm tracking-[0.3em] uppercase">
          Техническая пауза
        </p>
        <h1 className="font-display text-3xl font-bold">
          Упс! Что-то пошло не так.
        </h1>
        <p className="mt-4 text-white/70">
          Команда уже уведомлена об ошибке. Попробуйте перезагрузить блок или
          вернитесь на главную страницу.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <button
            type="button"
            onClick={reset}
            className="bg-luxury-green text-luxury-dark hover:bg-luxury-green-light rounded-md px-6 py-3 text-sm font-semibold tracking-wider uppercase transition"
          >
            Попробовать снова
          </button>
          <Link
            href="/"
            className="rounded-md border border-white/20 px-6 py-3 text-sm font-semibold tracking-wider text-white uppercase transition hover:border-white/40"
          >
            На главную
          </Link>
        </div>
        {error.digest && (
          <p className="mt-6 text-xs text-white/40">
            Код ошибки: {error.digest}
          </p>
        )}
      </div>
    </div>
  );
}
